export default "__VITE_ASSET__MI8sbe3g__"